import React from "react";

export default ({ size = 1 }) => (
    <div className={`my-${size}`}>
    </div>
);
